const common = require('./common');

module.exports = {
  ...common,
};
